$(document).ready(function () {
    $(document).on("click", "li.selectable:not(.disabled)", function (e) {
        return toggleState($(this));
    });

    $(document).on("click", "li.selectable:not(.disabled) input", function (e) {
        e.preventDefault();
        var $el = $(this).parents(".selectable").first();
        var $checkbox = $(".styledCheckbox:not(.disabled)", $el);
        var $checkboxv2 = $(".zbr-checkbox[data-type='styledCheckbox']:not(.disabled)", $el);
        var hasCheckbox = false;

        if ($checkbox != null) {
            hasCheckbox = true;
            if (!$checkbox.hasClass("selected")) {
                return toggleState($el);
            }
        }

        if ($checkboxv2 != null) {
            hasCheckbox = true;
            if (!$checkboxv2.hasClass("selected")) {
                return toggleState($el);
            }
        }

      //  if (!hasCheckbox) return false;

        return toggleState($el);
    });

    function toggleState($el) {
        $el.children(".styledCheckbox:not(.disabled), .styledRadiobutton:not(.disabled)").trigger("click");
        // checkbox v2
        $el.children(".zbr-checkbox[data-type='styledCheckbox']:not(.disabled), .zbr-radiobutton[data-type='styledRadiobutton']:not(.disabled)").trigger("click");
        //console.log($el.children(".zbr-checkbox[data-type='styledCheckbox']:not(.disabled)"));
        return false;
    }
})